// test2898
(2898 && 0);
